<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd = true">新增</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="name">
                            <el-input v-model="formInline.name" @input="handlerChange" placeholder="请输入检测项目" prefix-icon="el-icon-search"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <!-- 新增检测项目 -->
                <el-dialog :title="title" :visible.sync="handleAdd" width="500px" center @close="dialogClose">
                    <el-form :model="form" :rules="addrules" ref="form" label-width="120px">
                        <el-form-item prop="type" label="检测分类：">
                            <el-select v-model="form.type" :disabled="form.disabled" placeholder="请选择检测类型" style="width: 290px;" @change="typeChange">
                                <el-option label="材料检测" value="material"></el-option>
                                <el-option label="路面路基检测" value="subgrade"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="pid" label="上级栏目：">
                            <el-select v-model="form.pid" placeholder="请选择上级栏目" style="width: 290px;">
                                <el-option label="无" value="0"></el-option>
                                <el-option v-for="(item,index) in titleList" :key="index" :label="item.name" :value="item.id" v-show="item.pid == 0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="name" label="检测项目：">
                            <el-input v-model="form.name" autocomplete="off" placeholder="请输入检测项目" style="width: 290px;"></el-input>
                        </el-form-item>
                        <el-form-item prop="price" label="价格：" style="margin-bottom: 0;">
                            <el-input v-model="form.price" autocomplete="off" placeholder="请输入价格(￥)" style="width: 290px;"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleAdd = false">取消</el-button>
                        <el-button type="primary" @click="submitFormAdd('form')" v-if="!handleEditBtn">确认</el-button>
                        <el-button type="primary" @click="submitFormEdit('form')" v-else>确认</el-button>
                    </div>
                </el-dialog>
                <div class="bot">
                    <el-table
                        ref="singleTable"
                        class="xiangmu"
                        v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%;"
                        max-height="100%"
                        height="100%"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="type"
                        label="检测分类"
                        width="285">
                            <template slot-scope="scope">
                                {{ scope.row.type == 'material' ? '材料检测' : '路面路基检测' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        :formatter="problemSourceFormat"
                        label="检测项目"
                        width="285">
                        </el-table-column>
                        <el-table-column
                        prop="price"
                        label="价格(￥)"
                        width="285">
                            <template slot-scope="scope">
                                ￥{{ scope.row.price }}    
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="createtime"
                        :formatter="dateFormat"
                        label="时间"
                        width="280">
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <!-- <div class="page">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import { basis_project_index, basis_project_add, basis_project_edit, basis_project_del, basis_project_details } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                multipleSelection: '',
                // 新增报告模板弹窗默认隐藏
                title: '新增检测项目',
                handleAdd: false,
                handleEditBtn: false,
                form: {
                    id: '',
                    price: '',
                    name: '',
                    type: 'material',
                    pid: '0',
                    disabled: false // 
                },
                addrules: {
                    name: [
                        { required: true, message: '请输入检测项目', trigger: 'blur' }
                    ],
                    price: [
                        { required: true, message: '请输入价格', trigger: 'blur' }
                    ]
                },
                // 上级栏目列表
                titleList: [],
                // 筛选
                formInline: {
                    name: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入检测项目', trigger: 'blur' }
                    ]
                },
                // 数据列表
                loading: false,
                tableData: [],
                // total: 0,
                // per_page: 10, //每页多少数据
                // page: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 上级栏目列表
                getTitle() {
                    this.loading = true;
                    basis_project_index({
                        params: {
                            type: this.form.type
                        }
                    }).then((res) => {
                        // console.log("上级栏目",res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.titleList = res.data.data;
                        }
                    });
                },
                pidDisabled() {
                    if (this.form.pid !== '0') {
                        this.form.disabled = true
                    } else {
                        this.form.disabled = false
                    }
                },
                // 列表
                basisProjectIndex() {
                    this.loading = true;
                    basis_project_index().then((res) => {
                        // console.log(res);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data;
                            this.getTitle() // 更新新增弹窗上级栏目列表
                            // this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        basis_project_del({
                            ids: multipleSelection
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                // this.page = 1;
                                this.basisProjectIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            basis_project_index({
                                params: {
                                    name: this.formInline.name,
                                    // page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data;
                                    // this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 搜索框输入数据为空显示初始数据
                handlerChange(e) {
                    // console.log(e);
                    if (e == '') {
                        this.basisProjectIndex(); // 调用数据列表函数
                    }
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 检测分类
                typeChange(val) {
                    // console.log(val);
                    this.form.type = val;
                    this.form.pid = '0'; // 不重置会导致显示错乱
                    // 刷新上级栏目
                    basis_project_index({
                        params: {
                            type: this.form.type
                        }
                    }).then((res) => {
                        // console.log("上级栏目",res.data.data);
                        if (res.data.code == 1) {
                            this.titleList = res.data.data;
                        }
                    });
                },
                // 新增检测项目
                submitFormAdd(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.form.name,this.form.type,this.form.price,this.form.pid);
                            basis_project_add({
                                type: this.form.type,
                                pid: this.form.pid,
                                name: this.form.name,
                                price: this.form.price
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.code == 1) {
                                    // this.page = 1;
                                    this.handleAdd = false;
                                    this.basisProjectIndex(); // 调用数据列表函数
                                }
                                this.$message({
                                    type: 'success',
                                    message: '添加成功'
                                });
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 行数据编辑
                handleEdit(row) {
                    // console.log(row);
                    this.handleAdd = true;
                    this.handleEditBtn = true; // 判断是是新增还是编辑
                    this.title = '编辑检测项目';
                    this.form.id = row.id;
                    this.form.type = row.type;
                    if (row.pid == 0) {
                        this.form.pid = row.pid.toString();
                    } else {
                        this.form.pid = row.pid;
                    }
                    this.form.price = row.price;
                    // 更新上级栏目列表
                    basis_project_index({
                        params: {
                            type: this.form.type
                        }
                    }).then((res) => {
                        // console.log("上级栏目",res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.titleList = res.data.data;
                        }
                    });
                    // 获取子级栏目不带符号的名称
                    basis_project_details({
                        id: this.form.id,
                        type: this.form.type
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.code == 1) {
                            this.form.name = res.data.data.name
                        }
                    });
                },
                // 编辑检测项目
                submitFormEdit(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.form.id,this.form.type,this.form.name,this.form.price);
                            basis_project_edit({
                                id: this.form.id,
                                pid: this.form.pid,
                                type: this.form.type,
                                name: this.form.name,
                                price: this.form.price
                            }).then((res) => {
                                // console.log(res);
                                if (res.data.code == 1) {
                                    // this.page = 1;
                                    this.handleAdd = false;
                                    this.basisProjectIndex(); // 调用数据列表函数
                                }
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                });
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // dislog弹窗关闭清除数据以及验证
                dialogClose() {
                    this.title = '新增检测项目';
                    this.$refs['form'].resetFields(); // 清除验证提示文字
                    this.form.type = 'material';
                    this.form.pid = '0';
                    this.form.name = '';
                    this.form.price = '';
                },
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        basis_project_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                // this.page = 1;
                                this.basisProjectIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(val) {
                    console.log(`当前页: ${val}`);
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.createtime*1000)
                    let data = row.createtime * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                },
                // &nbsp;转义成空字符串
                problemSourceFormat: function(data){
                    if(data.name){
                        return data.name.replace(/&nbsp;/ig, "");
                    }
                }
            },
            created() {
                this.basisProjectIndex(); // 列表
                this.getTitle(); // 上级栏目列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style>
      
  </style>
  


// WEBPACK FOOTER //
// src/components/xiangmu.vue